<template>
  <div class="autocomplete-popup__close-button-container q-d-none q-d-md-block">
    <button id="autocomplete-popup__close-button"
            class="autocomplete-popup__close-button q-btn q-btn-close q-btn-lg"
            @click="popupStore.hideAutocomplete">
    </button>
  </div>
</template>

<script setup lang="ts">
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

const popupStore = usePopupStore();
</script>

<style scoped>
#autocomplete-popup__close-button {
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1090;
}
</style>